export function secondsToDHM(totalSeconds: number | string | undefined) {
	const s = Math.max(0, Number(totalSeconds) || 0);
	const days = Math.floor(s / 86400);
	const hours = Math.floor((s % 86400) / 3600);
	const minutes = Math.floor((s % 3600) / 60);

	const pad = (n: number) => String(n).padStart(2, '0');
	return {
		days,
		hours,
		minutes,
		dd: pad(days),
		hh: pad(hours),
		mm: pad(minutes),
	};
}
